import React, {useState, useEffect, useRef} from "react";
import {Card, CardBody, Container, Row} from "reactstrap";
import Swal from "sweetalert2";

import ApiService from "../util/ApiService";
import ScaleModal from "../dashboard/calender/scaleModal";
import LoadingScreen from "../util/LoadingScreen";

import HospitalSearch from "../hospital/HospitalSearch";
import UsersSearch from "../dashboard/calender/UsersSearch";
import Select from "react-select";
import TasksKanban from "./MainPage";
import BreadCrumb from '../../../Components/Common/BreadCrumb'
import CustomDropdownIndicator from "../../components/util/CustomDropdownIndicator";
import HospitalDepartmentModal from "../hospital/HospitalDepartmentModal";

import { DatePicker } from 'antd';

import { FaCheckCircle, FaEye  } from 'react-icons/fa';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'; // importa o locale pt-br
dayjs.locale('pt-br');       // aplica o locale

import ptBR from 'antd/es/date-picker/locale/pt_BR'; // locale do Ant Design


const ScaleConfigPage = () => {
    document.title = "Escala Padrão - Configuração | Plantão Rápido";
    const refUserSearch = useRef(null);
    const refHospitalSearch = useRef(null);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [showScaleModal, setShowScaleModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userOptions, setUserOptions] = useState(null);
    const [hospitalOptions, setHospitalOptions] = useState(null);
    const [arraScale, setArrayScale] = useState([]);
    const [scale, setScale] = useState([]);

    const [showHospitalDepartmentModal, setShowHospitalDepartmentModal] = useState(false);
    const [hospitalSelectDepartment, setHospitalSelectDepartment] = useState(null);
    const [departmentSelectDepartment, setDepartmentelectDepartment] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(dayjs().add(1, 'month')); // já começa no próximo mês
    const [checkConflicts, setCheckConflicts] = useState(false);

    const handleToggleCheckConflicts = () => {
        setCheckConflicts(prev => !prev);
    };
    const getCurrentWeekOfMonth = () => {
        const today = dayjs();
        const startOfMonth = today.startOf("month");
        const weekNumber = Math.ceil(today.date() / 7); // Divide os dias pelo número da semana

        return weekNumber > 5 ? 5 : weekNumber; // Se passar da 5ª semana, mantém como 5
    };

    const handleHospitalDepartmentModalClose = () => {
        setShowHospitalDepartmentModal(false);
    };

    const [filters, setFilters] = useState({
        user_id: "",
        hospital: "",
        order_month: "",
        department_id: "",
    });

    const [filtersPeriod, setFiltersPeriod] = useState({
        morning : true,
        late : true,
        night: true,
        user_not_filled: false,
        user_conflicts: false
    });

    const handleOpen = () => {
        setScale(null);
        setShowScaleModal(true);
    }

    const handleEdit = (scale) => {
        setScale(scale);
        setShowScaleModal(true);
    }

    const onHospitalSelect = (hospital) => {
        setFilters({...filters, hospital_id: hospital?.value || null});
    };

    const handleClearFilters = () => {
        setFilters({
            hospital_id: "",
            user_id: "",
            order_month: "",
            department_id: null,
        });

        if (refUserSearch.current) {
            refUserSearch.current.clearUser();
        }

        if (refHospitalSearch.current) {
            refHospitalSearch.current.clearHospital();
        }
    };

    useEffect(() => {
        fetchDepartment();
        setFilters(prevFilters => ({
            ...prevFilters,
            order_month: prevFilters.order_month || getCurrentWeekOfMonth(),
        }));

    }, []);

    useEffect(() => {
        if (filters.order_month !== "")
            fetchArray();
    }, [filters, selectedMonth, checkConflicts]);


    const handleGenerate = async () => {
        try {
            setLoading(true);
            // Monta os parâmetros, apenas incluindo aqueles que estão definidos
            const params = {
                order_month: filters.order_month !== undefined && filters.order_month !== null ? filters.order_month : null,
                hospital_id: filters?.hospital_id ? filters?.hospital_id : null,
                department_id: filters?.department_id ? filters?.department_id : null,
                user_id: filters.user_id
            };
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments-hospital/generate-scale`,
                params,
                true
            );

            Swal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: response.data.message,
            }).then(() => {
                fetchArray(); // Atualiza após o alerta ser fechado
            });
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }

    }


    const fetchArray = async () => {
        try {
            setLoading(true);
            // Monta os parâmetros, apenas incluindo aqueles que estão definidos
            const params = {
                order_month: filters.order_month !== undefined && filters.order_month !== null ? filters.order_month : null,
                hospital_id: filters?.hospital_id ? filters?.hospital_id : null,
                department_id: filters?.department_id ? filters?.department_id : null,
                user_id: filters.user_id,
                isConfig: true,
                month: selectedMonth?.format('YYYY-MM') ?? null,
                check_conflict: checkConflicts
            };
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}scale/list`,
                params,
                true
            );

            const {data} = ApiService.handleApiResponse(response);

            setArrayScale(data || []);
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    const handleScaleModalClose = (save = false) => {
        setShowScaleModal(false);
        if (save) {
            fetchArray();
        }
    };

    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}departments/list-department`, {
                all: true,
                status: 'S'
            }, true);

            const {data} = ApiService.handleApiResponse(response);

            const options = data.map((department) => ({
                value: department.id,
                label: department.name,
            }));

            setDepartmentOptions(options);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const onUserSelect = (users) => {
        setFilters({...filters, user_id: users?.value || null});
    };


    const handleDepartmentConfig = () => {
        const selectedDepartment = departmentOptions.find(
            (d) => d.value === filters.department_id
        );
        setDepartmentelectDepartment(selectedDepartment);
        setShowHospitalDepartmentModal(true);
    };


    return (
        <>
            {loading && <LoadingScreen/>}
            <React.Fragment>
                <div className="page-content scale-kanban-pag">
                    <Container fluid>
                        <BreadCrumb title="Configurar" pageTitle="Escala Padrão"/>
                        <div className="mb-2">


                            <div className="row">
                                <div className="col-4">
                                    <div className="d-flex gap-4 flex-wrap">
                                        <div className=" d-flex align-items-center gap-1">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="morning"
                                                checked={filtersPeriod.morning}
                                                onChange={() => setFiltersPeriod(prev => ({
                                                    ...prev,
                                                    morning: !prev.morning
                                                }))}
                                            />
                                            <label className="d-flex align-items-center m-0" htmlFor="morning"
                                                   style={{fontSize: '0.9rem', cursor: 'pointer'}}>
                                                <i className="fa-solid fa-sun" style={{marginRight: "4px", lineHeight: 1}}></i> Manhã
                                            </label>
                                        </div>

                                        <div className="d-flex align-items-center gap-1">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="late"
                                                checked={filtersPeriod.late}
                                                onChange={() => setFiltersPeriod(prev => ({...prev, late: !prev.late}))}
                                            />
                                            <label className="d-flex align-items-center m-0" htmlFor="late"
                                                   style={{fontSize: '0.9rem', cursor: 'pointer'}}>
                                                <i className="fa-solid fa-cloud-sun" style={{marginRight: "4px", lineHeight: 1}}></i> Tarde
                                            </label>
                                        </div>

                                        <div className="d-flex align-items-center gap-1">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="night"
                                                checked={filtersPeriod.night}
                                                onChange={() => setFiltersPeriod(prev => ({
                                                    ...prev,
                                                    night: !prev.night
                                                }))}
                                            />
                                            <label className="d-flex align-items-center m-0" htmlFor="night"
                                                   style={{fontSize: '0.9rem', cursor: 'pointer'}}>
                                                <i className="fa-solid fa-moon" style={{marginRight: "4px", lineHeight: 1}}></i> Noite
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3 ">
                                    <div className="d-flex align-items-center gap-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="night"
                                            checked={filtersPeriod.user_not_filled}
                                            onChange={() => setFiltersPeriod(prev => ({
                                                ...prev,
                                                user_not_filled: !prev.user_not_filled
                                            }))}
                                        />
                                        <label
                                            className="d-flex align-items-center m-0"
                                            htmlFor="night"
                                            style={{fontSize: '0.9rem', cursor: 'pointer'}}
                                        >
                                            <i className="fa fa-exclamation-triangle text-warning"
                                               style={{marginRight: "4px", fontSize: '1rem'}}></i>
                                            Usuário Não Preenchido
                                        </label>

                                    </div>
                                    {checkConflicts && (
                                    <div className="d-flex align-items-center gap-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="night"
                                            checked={filtersPeriod.user_conflicts}
                                            onChange={() => setFiltersPeriod(prev => ({
                                                ...prev,
                                                user_conflicts: !prev.user_conflicts
                                            }))}
                                        />
                                        <label
                                            className="d-flex align-items-center m-0"
                                            htmlFor="night"
                                            style={{fontSize: '0.9rem', cursor: 'pointer'}}
                                        >
                                            <i className="fa-solid fa-ban text-danger"
                                               style={{marginRight: "4px", fontSize: '1rem'}}></i>
                                            Conflito
                                        </label>

                                    </div>
                                        )}
                                </div>
                                <div className="col-4 d-flex align-items-center gap-2 mb-3">
                                    <DatePicker
                                        locale={ptBR}
                                        picker="month"
                                        format="MMMM YYYY"
                                        value={selectedMonth}
                                        onChange={setSelectedMonth}
                                        className="form-control"
                                        style={{maxWidth: '200px'}}
                                    />
                                    <button
                                        type="button"
                                        className={`btn d-flex align-items-center ${checkConflicts ? 'btn-success' : 'btn-light'}`}
                                        onClick={handleToggleCheckConflicts}
                                    >
                                        {checkConflicts ? (
                                            <>
                                                <FaCheckCircle className="me-1"/>
                                                Conflitos Ativados
                                            </>
                                        ) : (
                                            <>
                                            <FaEye  className="me-1"/>
                                                Mostrar Conflitos
                                            </>
                                        )}
                                    </button>

                                </div>
                            </div>
                        </div>


                        <div className="hstack gap-2 mb-3">
                            <div className="col-6 col-md-6 col-lg-1 col-xl-1 form-group">
                                <div className="form-group" style={{position: "relative"}}>
                                    <label>Ordem </label>
                                    <div className="user-input-group d-flex align-items-center">
                                        <select
                                            className="form-control"
                                            value={filters.order_month}
                                            onChange={(e) => setFilters({...filters, order_month: e.target.value})}
                                        >
                                            <option value="" disabled>
                                                Selecione
                                            </option>
                                            <option value="0">Todos</option>
                                            <option value="1">1ª Semana</option>
                                            <option value="2">2ª Semana</option>
                                            <option value="3">3ª Semana</option>
                                            <option value="4">4ª Semana</option>
                                            <option value="5">5ª Semana</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 col-xl-3 form-group">
                                <UsersSearch
                                    situation="accepted"
                                    buttonAdd={false}
                                    onUserSelect={onUserSelect}
                                    initialUser={userOptions}
                                    initialUserEditable={true}
                                />
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 col-xl-3 form-group">
                                <HospitalSearch
                                    buttonAdd={false}
                                    onHospitalSelect={onHospitalSelect}
                                    initialHospital={hospitalOptions}
                                    cache={false}
                                    validateManager={true}
                                />
                            </div>
                            <div className="col-12 col-lg-2 col-xl-2 col-md-6  form-group">
                                <div className="form-group" style={{position: "relative"}}>
                                    <label>Departamento</label>
                                    <Select
                                        isClearable={true}
                                        value={departmentOptions.find(option => option.value === filters.department_id) || null} // Define valor inicial
                                        onChange={(selectedOption) => setFilters({
                                            ...filters,
                                            department_id: selectedOption?.value || null // Armazena apenas o ID do departamento
                                        })}
                                        options={departmentOptions}
                                        placeholder="Selecione"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        components={{DropdownIndicator: CustomDropdownIndicator}}
                                        onConfigClick={handleDepartmentConfig}
                                    />
                                </div>
                            </div>
                            <button type="button" className="btn  btn-primary"
                                    style={{fontSize: '15px'}}
                                    onClick={() => handleOpen()}>
                                <i className="ri-add-line align-bottom me-1"></i> Cadastrar
                            </button>
                            <button type="button" className="btn  btn-warning"
                                    style={{fontSize: '15px'}}
                                    onClick={() => handleGenerate()}>
                                <i className="fa fa-hospital"></i> Preecher Vagas
                            </button>
                        </div>
                        <div className="kanban-scroll-wrapper">
                            <TasksKanban arraScale={arraScale} isLoading={isLoading} setLoading={setIsLoading}
                                         filtersPeriod={filtersPeriod}
                                         handleEdit={handleEdit} fetchArray={fetchArray}/>
                        </div>
                    </Container>
                </div>
            </React.Fragment>


            {showScaleModal && (
                <ScaleModal
                    show={showScaleModal}
                    handleClose={handleScaleModalClose}
                    filters={filters}
                    scale={scale}
                />
            )}

            <HospitalDepartmentModal
                show={showHospitalDepartmentModal}
                handleClose={handleHospitalDepartmentModalClose}
                hospital={hospitalSelectDepartment}
                department={departmentSelectDepartment}
            />

        </>
    );
};

export default ScaleConfigPage;
